module.exports = ".ba-actions a, .ba-actions a:link {\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n      user-select: none;\n  color: black;\n  font-weight: bold; }\n\n.ba-actions a:hover {\n  text-decoration: underline; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/client/my-settings/bank-accounts/bank-accounts.component.scss
// module id = ./src/app/pages/client/my-settings/bank-accounts/bank-accounts.component.scss
// module chunks = main